<template>
  <div>
    <v-tooltip
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar()">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar()">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesTipoArchivoContratista',
  props: {
    tipoArchivoContratista: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-tipo-archivo-contratista', this.tipoArchivoContratista);
    },
    borrar() {
      eventBus.$emit('eliminar-tipo-archivo-contratista', this.tipoArchivoContratista);
    },
  },
};
</script>

<style lang="scss"></style>
